import { combineReducers } from '@reduxjs/toolkit';
import ncdSlice from '../modules/ncd/ncdSlice';
import sickleSlice from '../modules/sickle/sickleSlice';
import pmndpSlice from '../modules/pmndp/pmndpSlice.enhanced';
import uwinSlice from '../modules/uwin/uwinSlice';
import nikshaySlice from '../modules/nikshay/nikshaySlice';

const rootReducer = combineReducers({
  ncd: ncdSlice,
  sickle: sickleSlice,
  pmndp: pmndpSlice,
  uwin: uwinSlice,
  nikshay: nikshaySlice,
});

export default rootReducer;